// 本地开发屏蔽错误发送，请按需修改
const ignoreUrls = [
    'localhost',
    '127.0.0.1',
    'localhost.qasandbox.bcetest.baidu.com',
    'qasandbox.bcetest.baidu.com',
    'local-subapp.eop.baidu-int.com',
];

const config = {
    common: {
        buildid: '1.0',
        token: 'becdd5509bcd439d9f167d6491818184',
    },
    error: {
        collectWindowErrors: true,
        collectUnhandledRejections: true,
        collectResourceLoadErrors: true,
        ignoreUrls: ignoreUrls,
    },
    perf: {
        sampleRate: 1,
        spa: true,
        history: true,
        ignoreUrls: ignoreUrls,
    },
};

export default config;
